import { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useTheme } from "@/comn/hooks";
import { Icon } from "@/comn/components";
import { sync } from "@/comn/features/context/LabelContext";

export const HeaderLanguageSelect = () => {
    const { theme, setTheme } = useTheme();
    const { t } = useTranslation();

    const [pending, setPending] = useState(false);

    const handleClick = async () => {
        if (pending) return;

        setPending(true);
        await sync();
        setPending(false);
    };

    return (
        <div className="flex">
            <div className="relative flex items-center">
                <select
                    className="input h-[40px] w-[80px] cursor-pointer bg-header rounded-r-none appearance-none"
                    value={theme.lang}
                    onChange={(e) => {
                        setTheme((prev) => ({ ...prev, lang: e.target.value as "ko" | "en" | "tz" }));
                    }}
                >
                    <option value="ko">{t("L_KO")}</option>
                    <option value="en">{t("L_EN")}</option>
                    <option value="tz">{t("L_SW")}</option>
                </select>
                <Icon icon="down" size="xs" className="absolute right-[10px] pointer-events-none" />
            </div>
            <div
                className={classNames(
                    "border-y border-r flex items-center justify-center px-1 rounded-r bg-header cursor-pointer",
                    "hover:bg-black/20",
                    pending && "pointer-events-none",
                )}
                onClick={handleClick}
            >
                {pending ? (
                    <Icon icon="loading" className="animate-spin" size="xs" />
                ) : (
                    <Icon icon="download" size="xs" />
                )}
            </div>
        </div>
    );
};
